<div
	class="mat-drawer-backdrop"
	(click)="layoutFacade.closeSidenav()"
	[class.mat-drawer-shown]="layoutFacade.showSidenav$ | async"
></div>

<mat-sidenav
	[opened]="layoutFacade.showSidenav$ | async"
	[fixedInViewport]="true"
	(keydown.escape)="layoutFacade.closeSidenav()"
>
	<mat-nav-list>
		<ng-content></ng-content>
	</mat-nav-list>
</mat-sidenav>
